export class SortingRule {
    public readonly fieldName: string;
    public readonly direction: "Ascending" | "Descending";

    public constructor(fieldName: string, direction: "Ascending" | "Descending") {
        this.fieldName = fieldName;
        this.direction = direction;
    }
}
